//mdc.utilities.color 
module.exports = {
    hsvToRgb,
    getColors
};

function getColors(numberOfColors) {   
    const result = [];
    const divisor = Math.floor(360 / numberOfColors);
    for (let i = 0; i < numberOfColors; i++) {
        let hue = (i * divisor);
        let sat = 0.45;
        let val = 0.65;
        let rgb = hsvToRgb(hue / 360, sat, val);
        let hexRgb = '#' + Math.floor(rgb[0]).toString(16)
            + Math.floor(rgb[1]).toString(16)
            + Math.floor(rgb[2]).toString(16);
        result.push([hue, hexRgb]);
        // For Debugging: console.log("hue: " + hue + " | hexRgb: " + hexRgb + " | rgb: " + rgb);
    }
    return result;
}



/**
 * Converts an HSV color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes h, s, and v are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   Number  h       The hue
 * @param   Number  s       The saturation
 * @param   Number  v       The value
 * @return  Array           The RGB representation
 */
function hsvToRgb(h, s, v) {
    let r, g, b;

    let i = Math.floor(h * 6);
    let f = h * 6 - i;
    let p = v * (1 - s);
    let q = v * (1 - f * s);
    let t = v * (1 - (1 - f) * s);

    switch (i % 6) {
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }

    return [r * 255, g * 255, b * 255];
}
